/* SLÉA homepage (h02). Loaded (defer) by sections/slea-home-h02.liquid.
   - Quantity stepper <-> the form's hidden quantity input <-> every price and button label shown
   - Product photo thumbnails
   - The LED drawing lights up once when it scrolls into view (instantly with reduced motion)
   - Phone sticky Add to cart bar: shows after the banner buy box, hides while any main Add to cart,
     the "Join the list" block or the footer is on screen ([data-h02-watch]); leaves room for
     Shopify's hCaptcha badge (same as v32)
   - "Join the list" is rendered hidden; shown only when the spin popup is on and ready to open
   - If an add from an outside button fails, scrolls the error message into view
   Never throws when an element is missing, and re-runs safely after theme-editor section reloads. */
(function () {
  'use strict';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // The spin popup (footer group) sets data-ready once its [data-slea-spin-open] listener is in
  // place. Without it (popup off, missing, iframe guard, CSS missing) the button would do nothing.
  function spinReady() {
    var s = document.querySelector('#slea-spin[data-enabled="true"][data-ready]');
    try { return !!(s && getComputedStyle(s).position === 'fixed'); } catch (e) { return false; }
  }
  function syncJoin(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var ok = spinReady();
    Array.prototype.forEach.call(scope.querySelectorAll('[data-h02-join]'), function (el) { el.hidden = !ok; });
  }
  function hasSpin(el) {
    return !!(el && el.querySelector && (el.id === 'slea-spin' || el.querySelector('#slea-spin')));
  }

  function init(root) {
    if (!root || root.h02Ready) return;
    root.h02Ready = true;
    var observers = [];
    root.h02Observers = observers;

    function q(s) { return root.querySelector(s); }
    function all(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    function each(s, fn) { all(s).forEach(fn); }

    /* ---------- quantity and prices ---------- */
    var prices = [];
    var pj = q('[data-h02-prices]');
    if (pj) {
      try { prices = JSON.parse(pj.textContent) || []; } catch (e) { prices = []; }
    }
    var max = prices.length || 10;
    var qtyInput = q('[data-h02-qty]');
    var announce = q('[data-h02-announce]');
    var n = 1;

    function setQty(next, say) {
      next = parseInt(next, 10);
      if (isNaN(next) || next < 1) next = 1;
      if (next > max) next = max;
      n = next;
      if (qtyInput) qtyInput.value = String(n);
      var p = prices[n - 1];
      each('[data-h02-qty-out]', function (el) { el.textContent = String(n); });
      each('[data-h02-qty-label]', function (el) { el.textContent = n > 1 ? 'Add ' + n + ' to cart' : 'Add to cart'; });
      if (p) {
        // Totals away from the stepper (banner, "Ten minutes", phone bar) also say the quantity
        each('[data-h02-total]', function (el) {
          el.textContent = p.t;
          if (n > 1 && el.hasAttribute('data-h02-total-q')) {
            var f = document.createElement('span');
            f.className = 'h02-for';
            f.textContent = ' for ' + n;
            el.appendChild(f);
          }
        });
        each('[data-h02-was]', function (el) { el.textContent = p.w; });
        each('[data-h02-save]', function (el) { el.textContent = p.s > 0 ? 'Save ' + p.s + '%' : ''; });
        each('[data-h02-saveline]', function (el) { el.hidden = !(p.s > 0); });
      }
      each('[data-h02-step]', function (b) {
        var down = Number(b.getAttribute('data-h02-step')) < 0;
        b.setAttribute('aria-disabled', (down ? n <= 1 : n >= max) ? 'true' : 'false');
      });
      // Screen readers hear the new total and saving, not just the number
      if (say && announce) {
        announce.textContent = 'Quantity ' + n + (p ? ', total ' + p.t + (p.s > 0 ? ' with ' + p.s + '% Bundle & save' : '') : '');
      }
    }
    // The browser can restore the hidden input after Back; start from whatever it holds
    setQty(qtyInput ? qtyInput.value : 1);

    /* ---------- photos ---------- */
    function showPhoto(i) {
      var slides = all('[data-h02-slide]');
      if (!slides[i]) return;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      each('[data-h02-go]', function (b) {
        b.setAttribute('aria-pressed', Number(b.getAttribute('data-h02-go')) === i ? 'true' : 'false');
      });
    }

    /* ---------- clicks (one listener for the whole section) ---------- */
    var clicked = null;
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var step = t.closest('[data-h02-step]');
      if (step) {
        if (step.getAttribute('aria-disabled') !== 'true') setQty(n + Number(step.getAttribute('data-h02-step')), true);
        return;
      }
      var go = t.closest('[data-h02-go]');
      if (go) { showPhoto(Number(go.getAttribute('data-h02-go'))); return; }
      clicked = t.closest('[data-h02-atc]');
    });

    /* ---------- busy state on the outside Add to cart buttons ----------
       They submit the one product form; product-form.js only marks its own button,
       so mirror its "loading" class onto the button that was actually tapped.
       product-form.js writes any error next to the main button; if the add was started
       from one of the outside buttons, scroll that message into view. */
    var mainAtc = q('[data-h02-main-atc]');
    var errWrap = q('.h02-err');
    if (mainAtc && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (mainAtc.classList.contains('loading')) {
          if (clicked) { clicked.classList.add('is-loading'); clicked.setAttribute('aria-busy', 'true'); }
        } else {
          each('[data-h02-atc].is-loading', function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
          var from = clicked;
          clicked = null;
          if (from && errWrap && !errWrap.hidden && errWrap.scrollIntoView) {
            errWrap.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
          }
        }
      });
      mo.observe(mainAtc, { attributes: true, attributeFilter: ['class'] });
      observers.push(mo);
    }

    /* ---------- LED drawing ---------- */
    var led = q('[data-h02-led]');
    if (led) {
      if (reducedMotion() || !('IntersectionObserver' in window)) {
        led.classList.add('is-lit');
      } else {
        var lo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { led.classList.add('is-lit'); lo.disconnect(); }
          });
        }, { threshold: 0.45 });
        lo.observe(led);
        observers.push(lo);
      }
    }

    /* ---------- Join the list: rendered hidden, shown only when the spin popup can open ---------- */
    syncJoin(root);

    /* ---------- phone sticky bar ---------- */
    var bar = q('[data-h02-sticky]');
    if (bar && 'IntersectionObserver' in window) {
      var heroBuy = q('[data-h02-herobuy]');
      var watched = all('[data-h02-watch]');
      var footer = document.querySelector('footer.footer') || document.querySelector('footer');
      var heroPast = !heroBuy;
      var footerOn = false;
      var badge = function () {
        var b = document.getElementById('shop-hcaptcha-badge-container');
        bar.classList.toggle('has-badge', !!(b && b.getBoundingClientRect().width > 0));
      };
      var update = function () {
        var atcOn = watched.some(function (el) { return el.h02On === true; });
        badge();
        bar.classList.toggle('is-show', heroPast && !atcOn && !footerOn);
      };
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === heroBuy) heroPast = !en.isIntersecting && en.boundingClientRect.top < 0;
          else if (en.target === footer) footerOn = en.isIntersecting;
          else en.target.h02On = en.isIntersecting;
        });
        update();
      });
      if (heroBuy) so.observe(heroBuy);
      if (footer && !root.contains(footer)) so.observe(footer);
      watched.forEach(function (el) { so.observe(el); });
      observers.push(so);
    }
  }

  function destroy(root) {
    if (!root || !root.h02Ready) return;
    (root.h02Observers || []).forEach(function (o) { try { o.disconnect(); } catch (e) {} });
    root.h02Observers = [];
    root.h02Ready = false;
  }

  function boot(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = Array.prototype.slice.call(scope.querySelectorAll('.slea-h02'));
    if (scope.classList && scope.classList.contains('slea-h02')) roots.unshift(scope);
    roots.forEach(function (root) {
      try { init(root); } catch (e) { if (window.console) console.error('slea-home-h02', e); }
    });
  }

  // Theme editor: a changed section is re-rendered and fires these events.
  // When the spin popup section itself changes (e.g. turned on or off), re-check "Join the list".
  if (!window.sleaH02Bound) {
    window.sleaH02Bound = true;
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
      if (hasSpin(e.target)) setTimeout(function () { syncJoin(document); }, 0);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.querySelectorAll) Array.prototype.forEach.call(e.target.querySelectorAll('.slea-h02'), destroy);
      if (hasSpin(e.target)) setTimeout(function () { syncJoin(document); }, 0);
    });
  }
  boot(document);
})();
